// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/google-icons/icon.css
// module id = 429
// module chunks = 11